import React from "react";
import { StaticImage } from "gatsby-plugin-image";
import { useTranslation } from "react-i18next";
import "../translations/i18n";
import { AnimatedOnScroll } from "react-animated-css-onscroll";

function Footer({ language }) {
  const { t } = useTranslation();

  return (
    <footer>
      <div className="upperFooter"></div>
      <div className={`${"innerFooter"} ${language == "ar" ? "ar" : ""}`}>
        <AnimatedOnScroll animationIn="fadeInRight" animationInDelay="500">
          <div className="social">
            <div className="footerLogo">
              <StaticImage width={200} src="../images/logo.svg" alt="Close" />
            </div>
          </div>
          <div className="contactInfo">
            <div className="social">
              <div className="socialIcons">
                <a href="https://www.facebook.com/TPYEMEN/" target="_blank">
                  <StaticImage
                    width={35}
                    src="../images/facebook.svg"
                    alt="Close"
                  />{" "}
                </a>
                <a href="https://www.twitter.com/TPYEMEN/" target="_blank">
                  <StaticImage
                    width={35}
                    src="../images/twitter.svg"
                    alt="Close"
                  />{" "}
                </a>
                <a href="https://www.instagram.com/tp.yemen/" target="_blank">
                  <StaticImage
                    width={35}
                    src="../images/instagram.svg"
                    alt="Close"
                  />{" "}
                </a>
                {/* <a href="">
                  <StaticImage
                    width={35}
                    src="../images/youtube.svg"
                    alt="Close"
                  />{" "}
                </a> */}
                <a href="https://www.t.me/TPYEMEN/" target="_blank">
                  <StaticImage
                    width={35}
                    src="../images/telegram.svg"
                    alt="Close"
                  />{" "}
                </a>
              </div>
              {/* <p>@tpyemen</p> */}
            </div>
            <div className="copyrights">
              <small>{t("copyrights")}</small>
            </div>
          </div>
        </AnimatedOnScroll>

        <AnimatedOnScroll animationIn="fadeInRight" animationInDelay="500">
          <div className="contactInfo">
            <ul>
              <li>
                <StaticImage width={30} src="../images/pin.svg" alt="Close" />
                <div className="contactDetails">
                  <p>{t("address")}</p>
                </div>
              </li>
              <li>
                <StaticImage
                  width={30}
                  src="../images/smartphone.svg"
                  alt="Close"
                />
                <div className="contactDetails">
                  <a href="#">{t("footerNum")}</a>
                </div>
              </li>
              <li>
                <StaticImage
                  width={25}
                  src="../images/phone-call.svg"
                  alt="Close"
                />
                <div className="contactDetails">
                  <a href="#">{t("footerLocalNum")}</a>
                </div>
              </li>
              <li>
                <StaticImage width={25} src="../images/email.svg" alt="Close" />
                <div className="contactDetails">
                  <a href="#">tpyemen@gmail.com</a>
                </div>
              </li>
            </ul>
          </div>
        </AnimatedOnScroll>

        <AnimatedOnScroll animationIn="fadeInRight" animationInDelay="500">
          <div className="map">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15391.095124290745!2d44.1914739!3d15.3345242!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x6f3fa40d02212ec3!2z2KrZgyDYqNix2YggKNiq2LPZiNmK2YIg2YjYpdi52YTYp9mGKQ!5e0!3m2!1sen!2s!4v1625901664553!5m2!1sen!2s"
              height="400"
              style={{ border: 0 }}
              allowfullscreen="true"
              loading="lazy"
            ></iframe>
          </div>
        </AnimatedOnScroll>
      </div>
    </footer>
  );
}

export default Footer;
